import { FC } from 'react';
import { WidgetProps } from '@rjsf/utils';
import FormInfo from 'components/form/FormInfo';

const InfoWidget: FC<WidgetProps> = ({ label }) => {
  return <FormInfo data={{ display_name: label }} />;
};

export default InfoWidget;
